import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterSubcategoryByForId'
})
export class FilterSubcategoryByForIdPipe implements PipeTransform {

  transform(value: any, parentForm: any): any {
    if(value) {
      const id = parentForm.get('propertyCategory').value;
      if(id) {
        return value.filter(item => item.forId === id);
      }
    }
    return value;
  }

}
